import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getMessageGroupDetail, getMessageGroupList } from "./Services";




export const useGetMessageGroups = (filter:any) => {

  const query = useQuery(
    [endpoints.getMessageGroupList,filter],
    () => {
      return getMessageGroupList(filter);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: 60000
    }
  );

  return query;
};

export const useGetMessageDetails:any = (filter:any) => {

  const query = useQuery(
    [endpoints.getMessageGroupDetail,filter],
    () => {
      return getMessageGroupDetail(filter);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: 60000
    }
  );

  return query;
};

;


